<script>
    import { createEventDispatcher } from "svelte";

    import AccountDoctorDetails from "./AccountDoctorDetails.svelte";
    import AccountUsersTable from "./AccountUsersTable.svelte";
    import AccountReports from "./AccountReports.svelte";
    import AccountInvoiceDetails from "./AccountInvoiceDetails.svelte";
    import { NoteTypes } from "../../../Utils/utilConstants.svelte";
    import Notes from "../../../Components/Common/Notes.svelte";
    import { user } from "../../../stores";

    export let doctorDetails = {};
    export let isEditEnabled = false;
    export let isUpdatingDoctor = false;
    export let userDetails = {};
    export let invoicesDetails = {};
    export let reload = () => {};

    $: isNotesTableVisible =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    const dispatch = createEventDispatcher();

    const saveDoctor = ({ detail }) => dispatch("saveDoctor", detail);
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 m-4">
        <AccountDoctorDetails
            bind:doctorDetails
            bind:isEditEnabled
            bind:isUpdatingDoctor
            on:saveDoctor={saveDoctor}
            on:cancelEdit={() => dispatch("cancelEdit")}
        />

        {#if isNotesTableVisible}
            <Notes
                sectionTitle="Notes"
                noteOwnerID={doctorDetails.id}
                noteType={NoteTypes.Account}
            />
        {/if}

        <AccountUsersTable
            accountId={doctorDetails.id}
            {userDetails}
            {reload}
        />
        
        <AccountReports accountId={doctorDetails.id}/>

        <AccountInvoiceDetails {invoicesDetails} />
    </div>
</div>
